import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button, { ButtonVariant } from "../button/button";
import { Flex, Text } from "@chakra-ui/react";
import { AgentActions, AgentDeatils as AgentField, AgentSelectors,  EmbeddingModel,  ModelType } from "src/redux/agents";
import { ChakraMenu, GroupItems } from "../chakra/menu-item";
import Icon, { IconVariant } from "../icon/icon";
import { AuthSelectors } from "src/redux/auth";
import { Plan } from "src/enums/enums";
import './agent.scss'
import "@uppy/core/dist/style.css";
import '@uppy/image-editor/dist/style.min.css';



const Item = (icon: IconVariant, title: string) => (<Flex align="center" key={title}>
    <Icon variant={icon} />
    <Text>{title}</Text>
</Flex>
)


const groupItems: GroupItems<ReactElement>[] = [
    {
        title: 'OpenAI',
        items: [
            Item(IconVariant.OPEN_AI_COLOR, ModelType.GPT3_5),
            Item(IconVariant.OPEN_AI_COLOR, ModelType.GPT4),
            Item(IconVariant.OPEN_AI_COLOR, ModelType.GPT4_1106)
        ]
    },
    {
        title: 'Antratopic',
        items: [
            Item(IconVariant.ANTHROPIC, ModelType.CLAUDE2_1)
        ]
    },
    {
        title: 'Meta',
        items: [
            Item(IconVariant.LLAMA, ModelType.LLAMA2_70B)
        ]
    }
]


const embedingModelItems = [EmbeddingModel.ADA2, EmbeddingModel.TITAN]





export default function AgentConfiguration({ onContinue }: {
    onContinue: () => void
}): ReactElement {
    const currentAgent = useSelector(AgentSelectors.currentAgent)
    const user = useSelector(AuthSelectors.user)
    const dispatch = useDispatch();
    




    const onChangeAgentDeatils = (value: string | object, agentDeatils: AgentField) => {
        dispatch(AgentActions.onChangeAgentDeatils({ value, agentDeatils }))
    }

    const onModelItemsSelect = (item: ReactElement) => {
        const index = Object.values(ModelType).findIndex((v) => v === item.key);
        const key = index !== -1 ? (Object.keys(ModelType)[index] as keyof typeof ModelType) : null;
        if (key !== null) {
            onChangeAgentDeatils(key, AgentField.MODEL);
        }
    }

    const onEmbeddingsModelItemsSelect = (item: string) => {
        const index = Object.values(EmbeddingModel).findIndex((v) => v === item);
        const key = index !== -1 ? (Object.keys(EmbeddingModel)[index] as keyof typeof EmbeddingModel) : null;
        if (key !== null) {
            const new_ingesting_param = { ...currentAgent?.ingesting_param, embedding_model: key }
            onChangeAgentDeatils(new_ingesting_param, AgentField.INGESTING_PARAM);
        }
    }

    const isOpenAI =
        ModelType[currentAgent!.model as string as keyof typeof ModelType] === ModelType.GPT3_5 ||
        ModelType[currentAgent!.model as string as keyof typeof ModelType] === ModelType.GPT4 ||
        ModelType[currentAgent!.model as string as keyof typeof ModelType] === ModelType.GPT4_1106




    return (
        <div className="agent agent-deatils">
            <div className="form">
                <div className="form-field">
                    <span className="form-field-label"> Model</span>
                    <ChakraMenu<ReactElement>
                        className="form-field-text"
                        currentItem={ModelType[currentAgent!.model as string as keyof typeof ModelType]}
                        onItemSelect={onModelItemsSelect}
                        withGroup
                        items={groupItems}
                        center={false}
                        textAlign="start"
                        background="white"
                        fontWeight="100"
                        
                    />
                </div>
                {isOpenAI && <div className="form-field">
                    <span className="form-field-label"> Open API Key (Optional)</span>
                    <input
                        className="form-field-text"
                        value={currentAgent?.openai_api_key}
                        onChange={(e) => onChangeAgentDeatils(e.target.value, AgentField.OPENAI_API_KEY)}
                        disabled={user.plan !== Plan.VIP}
                    />
                </div>}
                {user.officely_user && <div className="form-field">
                <span className="form-field-label"> Embeddings</span>
                    <ChakraMenu
                        className="form-field-text"
                        currentItem={EmbeddingModel[currentAgent!.ingesting_param?.embedding_model as string as keyof typeof EmbeddingModel] || EmbeddingModel.ADA2}
                        onItemSelect={onEmbeddingsModelItemsSelect}
                        items={embedingModelItems}
                        center={false}
                        textAlign="start"
                        background="white"
                        fontWeight="100"
                        
                    />
                    <span className="form-field-label"> Chunk Size</span>
                    <input
                        className="form-field-text"
                        value={currentAgent?.ingesting_param?.chunk_size || 700}
                        onChange={(e) => { 
                            const new_ingesting_param = { ...currentAgent?.ingesting_param, chunk_size: e.target.value }
                            onChangeAgentDeatils(new_ingesting_param, AgentField.INGESTING_PARAM)
                        }}
                        type="number"
                    />
                     <span className="form-field-label"> Chunk Overlap</span>
                    <input
                        className="form-field-text"
                        value={currentAgent?.ingesting_param?.chunk_overlap || 30}
                        onChange={(e) => { 
                            const new_ingesting_param = { ...currentAgent?.ingesting_param, chunk_overlap: e.target.value }
                            onChangeAgentDeatils(new_ingesting_param, AgentField.INGESTING_PARAM)
                        }}
                        type="number"
                    />
                    </div>}

            </div>
            <Button
                variant={ButtonVariant.PRIMARY}
                isBlock
                className="continue-button"
                onClick={onContinue}
            >

                Continue
            </Button>

        </div>
    );
}


